import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2c0145f4"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0145f4')) {
      api.createRecord('2c0145f4', component.options)
    } else {
      api.reload('2c0145f4', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2c0145f4", function () {
      api.rerender('2c0145f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/main.vue"
export default component.exports